<template>
  <el-container class='setTemplate'>
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch :searchList='searchList' ref='expSearch' :rightEventList="rightEventList"
        @rightFunc='rightFunc' v-on:getSearchObj='getSearchObj'>
      </publicExpandSearch>
    </div>
    <el-main class="container-box" v-loading="loading">
      <div class="i-container">
        <BaseTable :data="tableData" :optimize='true' tooltip-effect="dark" :column="tableConfig" :auto-scroll="true">
        </BaseTable>
      </div>
    </el-main>
    <el-dialog :visible.sync="setDialog" v-if="setDialog" :width="radio1 == 2 ? '95%' : '60%'">
      <div class="d-height">
        <div class="d-content">
          <div class="left" :style="{ width: radio1 == '2' ? '55%' : '100%' }">
            <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
              <div class="line-div">
                <span></span>
                <span>
                  发送：{{ sendData.title }}
                </span>
                <span style="font-size: 12px;color:#FB5555;margin-left: 15px;">注：大批量的用户推送可能会遭受微信惩罚</span>
              </div>
              <div class="left-item">
                <div class="item-left">
                  <div class="item-content">
                    <div class="c-left">行业：</div>
                    <div class="c-right">
                      {{ sendData.primary_industry ? sendData.primary_industry : '--' }}/{{ sendData.deputy_industry ?
                        sendData.deputy_industry : '--' }}
                    </div>
                  </div>
                  <div class="c-top">案例：</div>
                  <div class="c-bottom">
                    <div class="c-title">
                      <div class="c-content-name" v-for="(item, index) in sendData.str1" :key="index">{{ item }}</div>
                    </div>
                    <div class="c-view">
                      <div class="c-view-left">查看详情</div>
                      <div class="c-view-right">></div>
                    </div>
                  </div>
                  <div class="c-top">模板：</div>
                  <div class="c-bottom">
                    <div class="c-title">
                      <div class="c-content-name" v-for="(item, index) in sendData.str2" :key="index">{{ item }}</div>
                    </div>
                  </div>
                </div>
                <div class="item-right">
                  <div class="right-title">
                    <div class="right-title-left">推送方式：</div>
                    <div class="right-title-right">
                      <el-radio v-model="radio1" label="1">用户标签推送</el-radio>
                      <el-radio v-model="radio1" label="2">具体用户推送</el-radio>
                      <el-radio v-model="radio1" label="3">分组用户推送</el-radio>
                    </div>
                  </div>
                  <div class="right-title" v-if="radio1 == '1'">
                    <div class="right-title-left line">标签：</div>
                    <div class="right-title-right">
                      <el-select v-model="selectLable" filterable style="width: 340px;" placeholder="请选择"
                        @change="selectLabelFunction" value-key="id" size="small">
                        <el-option v-for="(item, index) in labelList" :key="index" :label="item.name" :value="item">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="right-title" v-if="radio1 == '3'">
                    <div class="right-title-left line">分组名称：</div>
                    <div class="right-title-right">
                      <el-select v-model="sendForm.groupId" style="width: 340px" size="small" filterable remote
                        reserve-keyword placeholder="请输入分组名称" :remote-method="remoteMethod" clearable
                        :loading="groupLoading">
                        <el-option v-for="item in groupListOption" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="right-title">
                    <div class="right-title-left"> 数据：</div>
                    <div class="right-title-box">
                      <el-form label-position="top" ref="form" size="small" :model="form" label-width="100px">
                        <el-form-item :label="item.key" v-for="(item, index) in sendForm.templateDtoList" :key="index">
                          <div style="display: flex;">
                            <el-input style="width: 280px;" v-model="item.value" :placeholder="'请输入' + item.key"
                              maxlength="200"></el-input>
                            <el-color-picker style="margin-left: 6px;" v-model="item.color">
                            </el-color-picker>
                          </div>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                  <div class="right-title">
                    <div class="right-title-left">跳转链接：</div>
                    <div class="right-title-right">
                      <div class="wechat-box">
                        <div class="wechat-box-one">小程序</div>
                        <el-switch v-model="value1"></el-switch>
                        <div class="wechat-box-two" v-if="value1">只跳转主体下的小程序</div>
                      </div>
                      <el-input class="right-input" v-if="value1" size="small" v-model="sendForm.appId"
                        placeholder="请输入小程序APP ID"></el-input>
                      <el-input class="right-input" size="small" v-if="value1" v-model="sendForm.pagePath"
                        placeholder="请输入跳转链接"></el-input>
                      <el-input class="right-input" size="small" v-if="!value1" v-model="sendForm.url"
                        placeholder="请输入url"></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bottom-btn">
                <el-button size="small" style="width:110px" @click="setDialog = false">取消</el-button>
                <el-button size="small" style="width:110px" type="primary" @click="sentTemplate()">
                  发送</el-button>
              </div>
            </el-scrollbar>
          </div>
          <div class="right" v-if="radio1 == '2'">
            <div class="line-div">
              <span></span>
              <span>
                用户列表
              </span>
            </div>
            <div class="dialog-search">
              <el-select v-model="userSelect" size='mini' style="width: 166px;margin-right:20px"
                @change="userSearchChange">
                <el-option label="用户微信名称" :value="1"></el-option>
                <el-option label="用户微信ID" :value="2"></el-option>
                <el-option label="用户手机号" :value="3"></el-option>
                <el-option label="关注状态" :value="4"></el-option>
              </el-select>
              <el-select v-if="userSelect == 4" v-model="userStatus" size='mini' style="width: 166px;margin-right:20px">
                <el-option label="已关注" :value="1"></el-option>
                <el-option label="未关注" :value="2"></el-option>
              </el-select>
              <el-input v-else :placeholder="selectPlace" style="width: 55%;margin-right:20px" size='mini'
                v-model="userInputValue">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <el-button type="primary" size='mini' @click="searchBtn()">搜索</el-button>
              <el-button size='mini' @click="resectSearch()">重置</el-button>
            </div>
            <div class="dialog-table">
              <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
                <el-table id="tableInfo" :data="wechatUserList" style="width: 100%" row-key="id"
                  @selection-change="handleSelectionChange">
                  <el-table-column type="selection" reserve-selection width="55" label="全选"></el-table-column>
                  <el-table-column prop="nickName" label="微信名称" align="center"></el-table-column>
                  <el-table-column prop="openId" show-overflow-tooltip label="微信ID" align="center"></el-table-column>
                  <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
                  <el-table-column prop="subscribe" label="关注状态" align="center">
                    <template slot-scope="scope">
                      <div>{{ scope.row.subscribe == 1 ? '已关注' : '未关注' }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-scrollbar>
            </div>
            <div class="dialog-pagination">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="wechatSearchForm.current" :page-size="wechatSearchForm.size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { wechatTypeNew } from "@/api/customService.js";
import {
  publicList,
  getLabelList,
  webSendTemplate,
  getWechatUser
} from "./api/index.js";
import { groupList } from "@/api/Patientmanagement.js";
export default {
  data() {
    //这⾥存放数据
    return {
      breadList: [{ name: '运营管理' }, { name: '模板消息' }],
      searchList: [
        {
          label: "公众号",
          paramName: "publicId",
          inputType: "select",
          default: '',
          optionData: [],
          upList: true
        },
        {
          label: "模板消息名称",
          paramName: "name",
          inputType: "input"
        },
      ],
      tableConfig: [
        {
          label: "模板ID",
          align: "center",
          prop: "template_id",
          showOverflowTooltip: true
        },
        {
          label: "模板名",
          align: "center",
          prop: "title",
          size: "mini"
        },
        {
          label: "一级行业",
          align: "center",
          prop: "primary_industry",
          size: "mini",
        },
        {
          label: "二级行业",
          align: "center",
          prop: "deputy_industry",
          size: "mini",
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.sendDetail(scope.row);
                    }
                  }
                },
                "发送"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.delData(scope.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      rightEventList: [{ eventName: "发送记录", eventValue: 1 }, { eventName: "同步模板", eventValue: 2 }],
      searchParams: {
        publicId: ''
      },
      userStatus: 1,
      searchSelect: 1,
      loading: false,
      // publicObj: {},
      userInputValue: "",
      selectPlace: "情输入用户微信名称",
      userSelect: 4,
      labelList: [],
      selectLable: "",
      value1: true,
      setDialog: false,
      radio1: "1",
      color1: "",
      groupListOption: [],
      groupLoading: false,
      total: 0, //每页10条
      tableData: [],
      ruleForm: {},
      publicIdArr: [],
      sendData: {},
      form: {},
      wechatUserList: [],
      wechatAppId: "",
      wechatSearchForm: {
        current: 1,
        size: 10,
        mobile: "", //用户手机号
        nickName: "", //用户微信名称
        openId: "", //用户id
        publicId: "" //公众号ID
      }, //选择用户列表搜索条件
      sendForm: {
        openIds: [], //用户IDS
        templateDtoList: [], //数据
        appId: "", //小程序id
        pagePath: "", //小程序路径
        labelId: "", //labelId
        labelName: "",
        publicAppId: "", //公众号ID
        templateId: "", //模板ID
        templateTitle: "", //模板标题
        url: "",
        groupId: "" //分组名称id
      }
    };
  },
  //监听属性类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //⽅法集合
  methods: {
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...this.searchParams, ...obj };
      this.getList()
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.$router.push("/termPage/setTemplate/sendRecord");
      } else {
        this.getList()
      }
    },
    userSearchChange(e) {
      this.wechatSearchForm.mobile = ""; //用户手机号
      this.wechatSearchForm.nickName = ""; //用户微信名称
      this.wechatSearchForm.openId = ""; //用户id
      if (e == 1) {
        this.selectPlace = "请输入用户微信名称";
      } else if (e == 2) {
        this.selectPlace = "请输入用户微信ID";
      } else if (e == 3) {
        this.selectPlace = "请输入用户手机号";
      } else if (e == 4) {
        this.selectPlace = "请输入公众号ID";
      }
    },
    //获取绑定公众号
    async getWechatType() {
      let res = await wechatTypeNew({ type: 2, ascription: "dsicm" });
      this.publicIdArr = res.data;
      this.searchList[0].optionData = res.data.map(item => {
        return {
          label: item.name,
          value: item.publicId
        }
      })
      this.searchList[0].default = res.data && res.data.length > 0 ? res.data[0].publicId : "";
      this.wechatAppId = res.data && res.data.length > 0 ? res.data[0].appId : "";
    },
    //切换公众号
    wechatAppChange(e) {
      this.searchParams.publicId = e.publicId;
      this.wechatAppId = e.appId;
      this.getList();
    },
    //获取模板消息列表
    getList() {
      if (!this.searchParams.publicId) {
        return
      }
      this.loading = true;
      publicList(this.searchParams).then(res => {
        this.tableData = res.data;
        this.loading = false;
      });
    },
    //删除单条模板消息
    delData(row, index) {
      this.$confirm("请前往对应的公众号后台删除", "提示消息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      });
    },
    //获取标签列表
    getLabelData() {
      getLabelList({
        publicId: this.searchParams.publicId
      }).then(res => {
        this.labelList = res.data;
      });
    },
    toSendRecord() {
      this.$router.push("/termPage/setTemplate/sendRecord");
    },
    //选择标签
    selectLabelFunction(e) {
      this.sendForm.labelId = e.id;
      this.sendForm.labelName = e.name;
    },
    //发送模板名
    sendDetail(row, index) {
      this.sendForm.templateTitle = row.title;
      this.sendForm.templateId = row.template_id;
      this.wechatSearchForm.publicId = this.searchParams.publicId;
      this.getLabelData();
      this.getGroupData();
      this.sendForm.templateDtoList = [];
      row.str1 = null;
      row.str2 = null;
      row.str1 = row.example.split("\r\n");
      row.str2 = row.content.split("\n");
      row.str2.forEach(item => {
        let a = item.indexOf("{") + 2;
        let b = item.indexOf(".");
        item = item.slice(a, b);
        let obj = {
          color: "",
          key: item,
          value: ""
        };
        this.sendForm.templateDtoList.push(obj);
      });
      this.sendData = row;
      this.getuserList();
      this.setDialog = true;
    },
    //确认发送按钮
    sentTemplate() {
      if (this.radio1 == "1") {
        //标签
        this.sendForm.openIds = [];
        this.sendForm.groupId = "";
      } else if (this.radio1 == "2") {
        //用户
        this.sendForm.labelName = "";
        this.sendForm.labelId = "";
        this.sendForm.groupId = "";
      } else {
        //分组
        this.sendForm.openIds = [];
        this.sendForm.labelName = "";
        this.sendForm.labelId = "";
      }
      let flag = false;
      let num = 0;
      let id = this.searchParams.publicId
      this.publicIdArr.map(item => {
        if (id == item.publicId) {
          this.wechatAppId = item.appId
        }
      })
      this.sendForm.publicAppId = this.wechatAppId;
      this.sendForm.templateDtoList.forEach(item => {
        if (!item.value && item.key != "remark") {
          flag = true;
        }
        if (item.value) {
          num += item.value.length;
        }
      });
      if (flag) {
        this.$message.error("请填写完数据后发送");
      } else if (num > 200) {
        this.$message.error("所有数据长度不可大于200");
      } else {
        this.send();
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.groupLoading = true;
        setTimeout(() => {
          this.groupLoading = false;
          this.getGroupData(query)
        }, 200);
      } else {
        this.groupListOption = [];
      }
    },
    getGroupData(name) {
      let param = {
        current: 1,
        size: 1000,
        name: name
      };
      groupList(param).then(res => {
        this.groupListOption = res.data.records;
      });
    },
    //获取公众号下用户列表
    getuserList() {
      if (this.userStatus == 2) {
        this.wechatUserList = [];
        return;
      }
      if (this.userSelect == 1) {
        this.wechatSearchForm.nickName = this.userInputValue;
      } else if (this.userSelect == 2) {
        this.wechatSearchForm.openId = this.userInputValue;
      } else if (this.userSelect == 3) {
        this.wechatSearchForm.mobile = this.userInputValue;
      } else if (this.userSelect == 4) {
        //
      }
      getWechatUser({ ...this.wechatSearchForm }).then(res => {
        this.total = res.data.total;
        this.wechatUserList = res.data.records;
      });
    },
    searchBtn() {
      this.wechatSearchForm.current = 1;
      this.wechatSearchForm.size = 10;
      this.getuserList();
    },
    //重置用户列表搜索条件
    resectSearch() {
      this.wechatSearchForm.current = 1;
      this.wechatSearchForm.size = 10;
      this.wechatSearchForm.mobile = "";
      this.wechatSearchForm.nickName = "";
      this.wechatSearchForm.openId = "";
      this.userInputValue = null;
      this.userStatus = 1;
      this.userSelect = 4;
      this.getuserList();
    },
    //发送接口
    send() {
      if (!this.value1) {
        this.sendForm.appId = null;
        this.sendForm.pagePath = null;
      }
      webSendTemplate({ ...this.sendForm }).then(res => {
        if (res.code == 0) {
          this.$message.success("成功");
          this.setDialog = false;
        }
      });
    },
    //表格多选
    handleSelectionChange(e) {
      this.sendForm.openIds = [];
      e.forEach(item => {
        this.sendForm.openIds.push(item.openId);
      });
    },
    //分页
    handleCurrentChange(e) {
      this.wechatSearchForm.current = e;
      this.getuserList();
    },
    handleSizeChange(e) {
      this.wechatSearchForm.size = e;
      this.getuserList();
    }
  },
  created() {
    this.getWechatType();
  },
  //⽣命周期 - 挂载完成（可以访问DOM元素）
  mounted() { }
};
</script>
<style scoped lang="less">
@import "./setTemplate.less";
</style>